// src/pages/FamilyTreePage.js
import React, { useEffect, useState } from "react";
import FamilyTreeStyled from "../components/FamilyTreeStyled";
import { getFamilyTree } from "../services/familyTreeService";

const FamilyTreePage = () => {
  const [family, setFamily] = useState(null); // 👈 This is correct

  useEffect(() => {
    getFamilyTree()
      .then((res) => {
        setFamily(res.data); // 👈 You store the family tree in `family`
      })
      .catch((err) => {
        console.error("Error fetching family tree:", err);
      });
  }, []);

  return (
    <div className="text-white">
      <h2 className="text-center my-4">👨‍👩‍👧‍👦 My Family Tree</h2>
      {family ? ( // 👈 use `family` here instead of `rootProfile`
        <FamilyTreeStyled root={family} />
      ) : (
        <p className="text-center">Loading...</p>
      )}
    </div>
  );
};

export default FamilyTreePage;
